import React from "react";

import { useTheme } from "@mui/material/styles";

import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";

const CardErrorPayment = ({ mensajeWarning, handleRender }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        minWidth: "100%",
        margin: "auto",
        borderRadius: "16px",
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Centrar el contenido verticalmente
        alignItems: "center",
        textAlign: "center",

        [theme.breakpoints.up("md")]: { width: "50%" },
        [theme.breakpoints.up("lg")]: { width: "100%" },
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Título de Error */}
        <Typography
          variant="h3"
          gutterBottom
          color="error.main"
          sx={{
            fontSize: "30px",
            padding: "2rem 0",
            margin: "0",
            "@media (max-width: 1360px)": {
              padding: "1rem 0",
              fontSize: "25px",
              fontWeight: "500",
            },
          }}
        >
          Error
        </Typography>

        {/* Icono de Error con el círculo y los elementos decorativos */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FFCDD2", // Fondo de color rojo claro
            borderRadius: "50%",
            width: 100,
            height: 100,
            position: "relative",
            mb: 3,
            "@media (max-width: 1360px)": {
              width: 70,
              height: 70,
            },
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 48, color: "#D32F2F" }} />
          {/* Ícono de error en color rojo */}
          {/* Elementos decorativos (pequeños círculos alrededor) */}
          <Box
            sx={{
              position: "absolute",
              top: -10,
              left: 20,
              width: 5,
              height: 5,
              bgcolor: "#FF6F60",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 20,
              right: -10,
              width: 5,
              height: 5,
              bgcolor: "#FF8A80",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -10,
              left: 10,
              width: 5,
              height: 5,
              bgcolor: "#FF5252",
              borderRadius: "50%",
            }}
          />
        </Box>

        {/* Mensaje de Error */}
        <Typography
          variant="h4"
          gutterBottom
          color="warning.success"
          sx={{ fontSize: "18px" }}
        >
          Pago fallido
        </Typography>

        {/* Descripción del Error */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, px: 2 }}
        >
          No se pudo completar el pago. Por favor, verifica tus datos o intenta
          nuevamente más tarde.
        </Typography>

        {/* Botón para intentar de nuevo */}
        <SCSGenericButton
          titulo="Intentar de nuevo"
          size={50}
          color="error"
          onClick={handleRender}
        />
      </CardContent>
    </Card>
  );
};
export default CardErrorPayment;
